import { Controller } from '@hotwired/stimulus';

import PlainTextEditor from 'apps/website/themes/inline_editor/PlainTextEditor';

export default class extends Controller {
  static values = {
    blockId: String,
    sectionId: String,
    attribute: String,
    style: {
      type: String,
      default: 'textarea',
    },
  };

  plainTextEditor = null;

  elementObserver = null;

  connect() {
    this._initElementObserver();
  }

  disconnect() {
    this._removeEditor();
    this._removeElementObserver();
  }

  _initEditor() {
    this.plainTextEditor = new PlainTextEditor(this.element, {
      blockId: this.blockIdValue,
      sectionId: this.sectionIdValue,
      attribute: this.attributeValue,
      style: this.styleValue,
    });
    this.plainTextEditor.init();
  }

  _removeEditor() {
    if (this.plainTextEditor) {
      this.plainTextEditor.remove();
      this.plainTextEditor = null;
    }
  }

  _initElementObserver() {
    if (this.elementObserver) return;

    this.elementObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this._initEditor();
      } else {
        this._removeEditor();
      }
    });

    this.elementObserver.observe(this.element);
  }

  _removeElementObserver() {
    if (this.elementObserver) {
      this.elementObserver.disconnect();
      this.elementObserver = null;
    }
  }
}
